import React from 'react';
import { CText } from '@carrefour/design-system-components-react';

interface ConnectedStoresCardProps {
  totalStores?: number;
  connectedStores?: number;
  onViewDetails?: () => void;
}

export const ConnectedStoresCard: React.FC<ConnectedStoresCardProps> = ({
  totalStores = 0,
  connectedStores = 0,
}) => {
  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <CText bold style={{ color: '#007BFF', marginRight: '8px' }}>
            {connectedStores} / {totalStores}
          </CText>
        </div>
        <CText bold style={{ color: '#7c7d7e' }}>
          {'Magasins'}
        </CText>
      </div>
    </div>
  );
};

export default ConnectedStoresCard;
